import { novelEntries } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";
import TagChip from "./TagChip";

export default function NovelSection() {
  return (
    <section id="novel" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="小说专区"
          title="漂亮的小姨子小说：按阅读方向分成五类入口"
          desc="同一部小说，不同读者的关注点并不相同。这里不重复介绍剧情，而是把阅读入口按目的拆开，让你直接找到想看的那一部分。"
        />

        <div className="mt-10 space-y-4">
          {novelEntries.map((entry, index) => (
            <article
              key={entry.id}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 rounded-lg border border-background-200 bg-background-100 p-4 md:p-6 transition-colors hover:border-primary-300"
            >
              <div className="md:col-span-1 flex md:flex-col items-center md:items-start gap-3">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl">
                  <i className={entry.icon}></i>
                </span>
                <span className="font-heading text-lg font-bold text-primary-300">
                  0{index + 1}
                </span>
              </div>

              <div className="md:col-span-8">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                    {entry.title}
                  </h3>
                  <span className="text-xs md:text-sm text-foreground-500">· {entry.subtitle}</span>
                </div>
                <p className="mt-2 text-sm md:text-base leading-relaxed text-foreground-600">{entry.desc}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {entry.tags.map((tag) => (
                    <TagChip key={tag}>{tag}</TagChip>
                  ))}
                </div>
              </div>

              <div className="md:col-span-3 flex md:justify-end items-start">
                <div className="rounded-md bg-background-50 border border-background-200 px-4 py-3 w-full md:w-auto">
                  <p className="text-xs text-foreground-500">阅读提示</p>
                  <p className="mt-1 text-sm text-foreground-800">{entry.meta}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}